<select [formControl]="selectControl" [id]="id" [class]="classes" (keyup)="handleDeletePress($event)" [attr.disabled]="disabled || isDisabled ? true : null">
  @if (placeholderMsg) {
    <option [ngValue]="null" hidden disabled class="sh-select__placeholder">{{ placeholderMsg }}</option>
  }
  @if (showEmptyOption) {
    <option [ngValue]="null">{{ emptyOptionLabel }}</option>
  }
  @if (extraOption) {
    <option value="{{ extraOption?.value }}" disabled>{{ extraOption?.label }}</option>
  }
  @for (option of options; track option) {
    <option value="{{ option.value }}" [attr.disabled]="disabled || isDisabled || option.disabled ? true : null" [title]="option.disabledInfoMsg">{{ option.label }}</option>
  }
</select>
